import { cn } from '../../lib/utils';

/**
 * Renders an explanation with proper formatting:
 * - Newlines rendered as paragraph breaks
 * - "Why the other options are wrong:" as a header
 * - Option lines (A-E patterns) as styled bullet points
 */
export const ExplanationRenderer = ({ text, className }) => {
    if (!text) return null;

    // Split into paragraphs by newlines
    const paragraphs = text.split(/\n+/).filter(p => p.trim());

    return (
        <div className={cn("space-y-3", className)} data-testid="explanation-text">
            {paragraphs.map((para, i) => {
                const trimmed = para.trim();

                // Headers like "Why the other options are wrong:"
                if (/^(why the other|why each|incorrect|wrong)/i.test(trimmed)) {
                    return (
                        <p key={i} className="font-semibold mt-2">
                            {trimmed}
                        </p>
                    );
                }

                // Option explanation lines: "A) ...", "- A: ...", "A. ...", "- B) ..."
                const optionMatch = trimmed.match(/^[-–•]?\s*([A-E])[).:]\s*(.*)/);
                if (optionMatch) {
                    return (
                        <div key={i} className="flex gap-2 pl-2">
                            <span className="font-semibold shrink-0 w-5">{optionMatch[1]}.</span>
                            <span>{optionMatch[2]}</span>
                        </div>
                    );
                }

                // "Correct answer: X) ..." line
                if (/^correct answer/i.test(trimmed)) {
                    return (
                        <p key={i} className="font-semibold">
                            {trimmed}
                        </p>
                    );
                }

                return <p key={i}>{trimmed}</p>;
            })}
        </div>
    );
};
